import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialLibraryModule } from '@cdw-ae/common-frontend-materials';
import { CdwAutocompleteModule } from '@cdw-ae/common-ui-components-autocomplete';
import { CommonUiComponentsBulkFieldUpdateModule } from '@cdw-ae/common-ui-components-bulk-field-update';
import { CdwButtonModule } from '@cdw-ae/common-ui-components-button';
import { CdwCheckboxModule } from '@cdw-ae/common-ui-components-checkbox';
import { CdwDialogModule } from '@cdw-ae/common-ui-components-dialog';
import { CdwDividerModule } from '@cdw-ae/common-ui-components-divider';
import { CdwDrawerModule } from '@cdw-ae/common-ui-components-drawer';
import { CdwIconModule } from '@cdw-ae/common-ui-components-icon';
import { CdwMessageBandModule } from '@cdw-ae/common-ui-components-message-band';
import { CdwSelectModule } from '@cdw-ae/common-ui-components-select';
import { CdwStepperModule } from '@cdw-ae/common-ui-components-stepper';
import { CdwProgressBarModule } from '@cdw-ae/common-ui-components-progress-bar';
import { CommonUiComponentsTextInputModule } from '@cdw-ae/common-ui-components-text-input';

import { CdwBulkUpdateActionComponent } from './cdw-bulk-update-action.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialLibraryModule,
    CommonUiComponentsTextInputModule,
    CdwAutocompleteModule,
    CdwSelectModule,
    CdwButtonModule,
    CdwCheckboxModule,
    CdwDialogModule,
    CdwDividerModule,
    CdwDrawerModule,
    CommonUiComponentsBulkFieldUpdateModule,
    CdwIconModule,
    CdwMessageBandModule,
    CdwStepperModule,
    CdwProgressBarModule,
  ],
  declarations: [CdwBulkUpdateActionComponent],
  exports: [CdwBulkUpdateActionComponent],
})
export class CommonUiComponentsBulkUpdateActionModule {}
